"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebUtils = void 0;
/**
 * Web utilities
 */
var WebUtils;
(function (WebUtils) {
    function encodeQuery(obj, prefix) {
        const str = [];
        for (const p in obj) {
            if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
                const k = prefix ? prefix + "[" + p + "]" : p;
                const v = obj[p];
                str.push(v !== null && typeof v === "object" ?
                    encodeQuery(v, k) :
                    encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
        }
        return str.join("&");
    }
    WebUtils.encodeQuery = encodeQuery;
    function joinUrlSegments(...args) {
        const parts = [];
        for (const arg of args) {
            if (!arg)
                continue;
            if (arg.startsWith("/"))
                parts.push(arg.substr(1, arg.length - 1));
            else if (arg.endsWith("/"))
                parts.push(arg.substr(0, arg.length - 1));
            else
                parts.push(arg);
        }
        return "/" + parts.filter(x => !!x).join("/");
    }
    WebUtils.joinUrlSegments = joinUrlSegments;
})(WebUtils = exports.WebUtils || (exports.WebUtils = {}));
//# sourceMappingURL=web.js.map